define('bizzabo/views/popup/ImagePreviewView',[
    'jquery',
    'backbone',
    'bizzabo/consts',
    'bizzabo/views/popup/PopupView',
    'hbars!bizzabo/templates/imagePreview'
], function(
    $,
    Backbone,
    Consts,
    PopupView,
    template
    ) {

    var ImagePreviewView = PopupView.extend({

        modalOptions : {
            keyboard : true,
            backdrop : 'static'
        },

        events : {
            'click .doneButton' : 'doneClicked',
            'click .close' : 'doneClicked'
        },

        initialize : function() {
            this.popUpInitialize();
        },

        renderImage : function() {
            var thisView  = this;
            var image = new Image();
            var $image = $(image);
            image.src = thisView.model.get('src');
            this.$el.css('position', 'relative');
            this.$el.css('left', '-99999px');
            $image.appendTo(this.$el).one('load', function() {
                var width = $image.width();
                var height = $image.height();
                $image.remove();
                var html = template(thisView.model.toJSON());
                thisView.$el.html(html);
                thisView.$el.css({
                    'width' : '0',
                    'height' : '0',
                    'margin-top' : 0,
                    'margin-left' : 0,
                    'position' : '',
                    'left' : ''
                });
                thisView.$el.animate({
                    'margin-top' : (height / -2),
                    'margin-left' : (width / -2),
                    'width' : width,
                    'height' : height
                });
            }).each(function() {
                this.complete && $(this).load();
            });
        },

        render : function() {
            return this;
        },

        viewRendered : function() {
            this.$el.modal({
                keyboard : true
            });

            this.renderImage();
        },

        doneClicked : function(e) {
            this.hide();
        }

    });

    return ImagePreviewView;

});
